import { TemporalEntityId } from 'entities-next/common'
import React, { useRef } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useMatchParams } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Card, Divider, Theme } from '@mui/material'

import { UserDetailsViewProvider } from './UserDetailsView.store'
import { UserDetailsViewContent } from './UserDetailsViewContent.component'
import { UserDetailsViewHeader } from './UserDetailsViewHeader.component'

export type UserDetailsViewProps = ExtendableStyles & Testable

export function UserDetailsView() {
  const { classes } = useStyles()
  const actionBarRef = useRef<any>(null)
  const { id } = useRouteVariables()
  return (
    <UserDetailsViewProvider userId={id} actionBarRef={actionBarRef}>
      <Card className={classes.content}>
        <UserDetailsViewHeader className={classes.header} />
        <Divider />
        <UserDetailsViewContent />
      </Card>
      <div className={classes.footer} ref={actionBarRef} />
    </UserDetailsViewProvider>
  )
}

function useRouteVariables() {
  const { userId = '' } = useMatchParams<{ userId: string }>()
  const id = Number(userId)
  if (isNaN(id)) {
    return {
      id: TemporalEntityId.new,
    }
  } else {
    return {
      id: id,
    }
  }
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: spacing(50),
  },
  header: {
    position: 'relative',
    width: '100%',
    height: spacing(12),
  },
  footer: {
    position: 'relative',
    paddingTop: spacing(3),
    paddingBottom: spacing(2),
    width: '100%',
    bottom: 0,
    right: 0,
  },
}))
